import { SectionName } from 'features/candidate/utils';
import { ProgAIMetadata } from 'shared/generated-models';
import { ProgAiOOSContribution } from 'shared/generated-models';

export const normalizeArray = (array: Array<any>, sectionName: SectionName, metadata?: ProgAIMetadata): Array<any> => {
	if (sectionName === 'oss_contribution' && metadata && metadata.found_skills) {
		const skills = new Set(metadata.found_skills.map(s => (s?.skill ?? '').toLowerCase()).filter(Boolean));

		const promoted: ProgAiOOSContribution[] = [];
		const rest: ProgAiOOSContribution[] = [];

		for (const item of array) {
			const topics = (item.topics ?? []).map((t: string) => t.toLowerCase());
			const hasMatch = topics.some((t: string) => skills.has(t));
			(hasMatch ? promoted : rest).push(item);
		}

		return [...promoted, ...rest];
	}

	if (sectionName !== 'experience') return array;

	const arrayCopy = [...array];

	const sortedData = arrayCopy.sort((a, b) => {
		const parseDate = (dateString: string) => (dateString ? new Date(dateString) : null);

		const aEndDate = a.current === 1 ? null : parseDate(a.endDate);
		const bEndDate = b.current === 1 ? null : parseDate(b.endDate);

		if (a.current === 1 && b.current !== 1) {
			return -1;
		}

		if (a.current !== 1 && b.current === 1) {
			return 1;
		}

		if (aEndDate && bEndDate) {
			const endDateComparison = bEndDate.getTime() - aEndDate.getTime();
			if (endDateComparison !== 0) {
				return endDateComparison;
			}
		}

		const aStartDate = a.startDate ? parseDate(a.startDate)?.getTime() : 0;
		const bStartDate = b.startDate ? parseDate(b.startDate)?.getTime() : 0;

		return (bStartDate || 0) - (aStartDate || 0);
	});

	return sortedData;
};
